<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0">
    <div>
      <div class="col px-0">
        <label class="custom-form-label" v-bind:for="'AutoCompletedLocation' + getId()">{{$t('address')}}</label><info-note v-bind:text="$t('location_message')"></info-note>
        <div class="mt-1" style="position:relative" id="locationField">
          <input type="text" onclick="initDefaultAutoCompleteLocations(this);" v-bind:name="'AutoCompletedLocation' + getId()" v-bind:placeholder="$t('type_address')" v-bind:id="'AutoCompletedLocation' + getId()" onfocus="" class="form-control input-lg">
        </div>
        <input type="hidden" v-model="lng" @input="positionChanged" v-bind:name="'AutoCompletedLocation' + getId() + 'longitude'" placeholder="longitude" value="" v-bind:id="'AutoCompletedLocation' + getId() + 'longitude'">
        <input type="hidden" v-bind:name="'AutoCompletedLocation' + getId() + 'latitude'" placeholder="latitude" value="" v-bind:id="'AutoCompletedLocation' + getId() + 'latitude'">
      </div>
    </div>
  </div>
</template>

<script>

  var items = [];
  var itemName = "";

  export default {
    name: "location-autocomplete",
    props: {
      placeholder: {
        type: String,
        default: "Search.."
      },
    },
    data() {
      return {
        itemName,
        items,
        lng:'',
      };
    },
    methods: {

      getId() {
        return this._uid;
      },
      positionChanged() {
        this.$emit("changed", $('#AutoCompletedLocation' + this.getId()).val(), $('#AutoCompletedLocation' + this.getId() + 'latitude').val(), $('#AutoCompletedLocation' + this.getId() + 'longitude').val());
      },
      getId() {
        return this._uid;
      },
      setValue(val, lat, lng) {
        $('#AutoCompletedLocation' + this.getId()).val(val)
        $('#AutoCompletedLocation' + this.getId() + 'latitude').val(lat)
        $('#AutoCompletedLocation' + this.getId() + 'longitude').val(lng)
      },
      clearValues() {
        $('#AutoCompletedLocation' + this.getId()).val('')
        $('#AutoCompletedLocation' + this.getId() + 'latitude').val('')
        $('#AutoCompletedLocation' + this.getId() + 'longitude').val('')
      }
    },
    watch: {
      longitude: function () {
        //this.positionChanged();
      }
    },
    mounted() {
    }
  };
</script>

<style>
  .pac-container {
    z-index: 100002 !important;
  }
</style>

<style scoped>
  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/location/location-autocomplete.vue